import { List } from "immutable";

import { OUTLINE_DEFAULT_COLUMN_WIDTH } from "../../../../constants";
import outlineColumnIds, { columnDefaultWidths } from "../../../../constants/outlineColumnIds";
import { TableViewColumnRecord } from "./TableViewColumnRecord";

const getColumnRecord = colId => {
  const width = columnDefaultWidths[colId] || OUTLINE_DEFAULT_COLUMN_WIDTH;
  return TableViewColumnRecord({
    id: colId,
    width: width
  });
};

export const defaultColumnsForSpreadsheetView = List([
  getColumnRecord(outlineColumnIds.label),
  getColumnRecord(outlineColumnIds.identifier),
  getColumnRecord(outlineColumnIds.sequence),
  getColumnRecord(outlineColumnIds.type),
  getColumnRecord(outlineColumnIds.color),
  getColumnRecord(outlineColumnIds.start),
  getColumnRecord(outlineColumnIds.duration),
  getColumnRecord(outlineColumnIds.end)
]);
